<template>
    <div class="content-box">
        <div class="grid justify-center">
            <div class="flex justify-center title">Serviços Oferecidos</div>
            <div class="flex justify-center sub-title">
                {{ slugInfo.descriptionGallery }}
            </div>
        </div>
        <div class="grid grid-cols-3 gap-4 card-box">
            <div v-for="(gallery, index) in slugInfo.gallery" :key="index" class="card">
                <div class="image-gallery" :style="backgroundImage(gallery.imageUrl)" />
                <h3 class="card-title">{{ gallery.label }}</h3>
                <div :class="['flex flex-1 flex-col justify-between mb-5', isMobile ? 'px-4' : 'px-8']">
                    <div class="text">
                        {{ gallery.description }}
                    </div>
                    <!-- <div class="flex mb-4 justify-center"> -->
                    <eg-button @click="goToForm" class="flex justify-center">
                        <span class="text-btn"
                            >Solicite um orçamento
                            <span class="material-icons-outlined"> keyboard_double_arrow_right </span>
                        </span>
                    </eg-button>
                    <!-- </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import { computed } from '@vue/composition-api';
export default {
    name: 'Gallery',
    props: {
        isMobile: [Boolean, Object],
        slugInfo: Object,
    },
    setup(_, { root }) {
        const goToForm = () => {
            root.$el.querySelector('#form').scrollIntoView({ behavior: 'smooth' });
            setTimeout(() => {
                root.$el.querySelector('#name input').focus();
            }, 500);
        };

        const backgroundImage = (url) => {
            {
                return {
                    'background-image': `url(${url})`,
                    'background-repeat': 'no-repeat',
                    'background-size': 'cover',
                };
            }
        };

        return { goToForm, backgroundImage };
    },
};
</script>

<style lang="scss" scoped>
.title {
    font-family: Open Sans;
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    color: #0f2d53;
    margin-top: 60px;
    text-align: center;
}
.sub-title {
    color: #7a7a7a;
    font-family: Open Sans;
    font-style: normal;
    font-size: 16px;
    text-align: center;
    margin-bottom: 60px;
}
.image-gallery {
    height: 176px;
    border-radius: 0.375rem 0.375rem 0rem 0rem;
}
// .text-btn {
//     text-transform: uppercase;
//     display: flex;
//     font-size: 16px;
//     text-align: center;
//     display: flex;
//     justify-content-box: center;
// }
.material-icons-outlined {
    top: 6px !important;
}
.text-btn {
    font-size: 16px;
    text-align: center;
    display: flexbox !important;
    text-transform: uppercase !important;
}
.content-box {
    @apply container mx-auto px-8;
    margin-bottom: 60px;
    .card-box {
        @media screen and (max-width: 767px) {
            @apply flex flex-wrap justify-center;
        }
        .card {
            @apply flex flex-col;
            background-color: white;
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            border-radius: 0.375rem;
            @media screen and (max-width: 767px) {
                width: 100%;
                margin-bottom: 30px;
            }
            .card-title {
                @apply font-bold mb-4 mt-4 text-center;
                font-size: 24px;
                color: #0e53a5;
                @media screen and (max-width: 1024px) {
                    font-size: 18px;
                }
            }
            .text {
                @apply grid justify-center  text-center mb-4;
                white-space: pre-line;
                font-size: 16px;
                color: #7a7a7a;
                // tablet
                @media screen and (max-width: 1024px) {
                    font-size: 13px;
                }
            }
        }
    }
}
.eg-button {
    padding: 8px !important;
}
@media screen and (max-width: 1024px) {
    .image-gallery {
        height: 98.59px;
    }
    .text-btn {
        font-size: 11px;
    }
    .material-icons-outlined {
        font-size: 15px;
    }
    .material-icons-outlined {
        top: 5px !important;
    }
}
@media screen and (max-width: 768px) {
    .image-gallery {
        height: 128px;
    }

    .title {
        font-size: 20px;
        @apply mb-3 mt-8;
    }
    .sub-title {
        font-size: 13px;
        @apply mb-7;
    }
}
</style>
